import * as React from "react";
import { connect } from "react-redux";
import { AppDispatch } from "app/store";
import { IAppState } from "app/rootReducer";
import { bindActionCreators } from "redux";
// component
import Navbar from "./components/navbar";
import SignUpEntranceComponent from "./components/signUpEntrance";
import MobileAppDownloadDialog from "common/components/mobileDialog";
import AuthRedirect, {
  ACCESS_PERMISSION_OPTIONS,
} from "@vingle/wtf-sdk/components/authRedirect";
import PageUpdater from "@vingle/wtf-sdk/components/pageUpdater";
// actions
import { ActionCreators } from "app/vingleDialog/actions";
import { trySignInWithFB } from "@vingle/wtf-sdk/actions/app";
// url
import { VingleURL } from "@vingle/wtf-sdk/url";

interface IProps
  extends ReturnType<typeof mapStateToProps>,
    ReturnType<typeof mapDispatchToProps> {}

function mapStateToProps(state: IAppState, _routerProps: any) {
  return {
    isMobileAppDownloadOpen: state.globalDialog.isMobileAppDownloadOpen,
  };
}

function mapDispatchToProps(dispatch: AppDispatch) {
  return bindActionCreators(
    {
      dispatchOpenMobileAppDownloadDialog:
        ActionCreators.openMobileAppDownloadDialog,
      dispatchCloseMobileAppDownloadDialog:
        ActionCreators.closeMobileAppDownloadDialog,
      dispatchTrySignInWithFB: trySignInWithFB,
    },
    dispatch,
  );
}

class SignUpEntranceContainer extends React.PureComponent<IProps> {
  public render() {
    const {
      isMobileAppDownloadOpen,
      dispatchTrySignInWithFB,
      dispatchOpenMobileAppDownloadDialog,
      dispatchCloseMobileAppDownloadDialog,
    } = this.props;

    return (
      <div
        style={{
          height: "100%",
          minHeight: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <PageUpdater title="Sign Up" />
        <AuthRedirect
          targetPath={new VingleURL.Home().toString()}
          permission={ACCESS_PERMISSION_OPTIONS.UNSIGNED_USER_ONLY}
        />
        <Navbar
          onRequestOpenAppDownloadDialog={dispatchOpenMobileAppDownloadDialog}
        />
        <MobileAppDownloadDialog
          isOpen={isMobileAppDownloadOpen}
          onRequestClose={dispatchCloseMobileAppDownloadDialog}
        />
        <SignUpEntranceComponent trySignInWithFB={dispatchTrySignInWithFB} />
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SignUpEntranceContainer);
